import React from "react";
import { useState } from "react";
import { t } from './../i18n';
import useApp from "../AppContext";

function PaginationControls({ currentPage, totalPages, onPageChange }) {
    const app = useApp()
    const [language] = useState(app.sessionToken?.Language);
    const handlePrevious = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onPageChange(currentPage - 1);
    };

    const handleNext = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onPageChange(currentPage + 1);
    };

    return (
        totalPages > 1 && (
            <div
                className="d-flex justify-content-between align-items-center mt-3"
                style={{
                    background: app.theme === 'dark' ? 'var(--bg-tertiary)' : 'white',
                    padding: '10px',
                    borderRadius: '22px',
                    color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit',
                }}
            >
                <button
                    type="button"
                    className="btn btn-sm btn-tablet-color"
                    disabled={currentPage === 1}
                    onClick={handlePrevious}
                >
                    {t('pagination.previous', language)}
                </button>

                <span> {t('pagination.pageInfo', language)
                    .replace('{current}', currentPage)
                    .replace('{total}', totalPages)}</span>

                <button
                    type="button"
                    className="btn btn-sm btn-tablet-color"
                    disabled={currentPage === totalPages}
                    onClick={handleNext}
                >
                    {t('pagination.next', language)}
                </button>
            </div>
        )
    );
}

export default PaginationControls;